import React from "react";
import { Helmet } from "react-helmet-async";

// Band structured data, rendered on every page inside <Layout>.
// Keep this identical to BandJsonLd in SeoPageRenderer.cs.
// The "@id" lets other pages (like /yacht-rock-band) add details to the same
// band entity instead of describing a second, conflicting one.
export const bandSchema = {
    "@context": "https://schema.org",
    "@type": "MusicGroup",
    "@id": "https://www.dysband.com/#band",
    "name": "Dirty Yachtin' Scoundrels",
    "description": "A Phoenix, Arizona yacht rock band performing smooth hits from the '70s and '80s.",
    "url": "https://www.dysband.com/",
    "logo": "https://www.dysband.com/dys-logo-black.png",
    "image": "https://www.dysband.com/media/yacht_rock_band_dirty_yachtin_scoundrels_live.webp",
    "genre": "Yacht Rock",
    "location": {
        "@type": "Place",
        "name": "Phoenix, Arizona",
        "address": {
            "@type": "PostalAddress",
            "addressLocality": "Phoenix",
            "addressRegion": "AZ",
            "addressCountry": "US"
        }
    },
    "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+1-480-430-7479",
        "contactType": "booking",
        "areaServed": "US",
        "availableLanguage": "en"
    },
    "sameAs": [
        "https://www.facebook.com/DYSYachtRock/",
        "https://www.instagram.com/dirtyyachtin",
        "https://www.youtube.com/channel/UCcu13H2X3Je7ATUCX_vlrKw"
    ]
};

const BandSchema = () => (
    <Helmet>
        <script type="application/ld+json">{JSON.stringify(bandSchema)}</script>
    </Helmet>
);

export default BandSchema;